module.exports = __webpack_public_path__ + "static/media/cntemad_logo.999f0842.png";